module.exports = __webpack_public_path__ + "img/logo.882783e0.png";